import React, { Component } from "react";
import { observer } from "mobx-react";
import { Accessor, ColorX, GFunc, IconX, LocaleX, ReqX, ZMath, ZTime, ZValidate } from "IZOX/STATIC";
// eslint-disable-next-line no-unused-vars
import PropsType from "prop-types";
import { ActivityIndicator, HStack, Spacer, VStack, XButton, XIconButton, XScroll, XText } from "IZOX/_X";
import Styles from "__SYSDefault/Styles";
import { QForm } from "IZOX/BLOCKS/Libs";
import QUICKUI from "shared/QUICKUI";
import { QFCheckBox, QFDropUpload } from "IZOX/BLOCKS/Libs/QForm/_gears";
import _ from "lodash";
import HTMLReactParser from "html-react-parser";
import disclaimerEN from "../_disclaimerEN";
import disclaimerTC from "../_disclaimerTC";
import VarList from "shared/VarList";

/**
 * @augments {Component<Props, State>}
 */
class NewClaimW extends Component {

  static propTypes = {

  }

  static defaultProps = {

  }

  constructor(){
    super();
    this.state = {
      formValue: {},
      curStep: 0,
      loading: false
    };
  }

  componentDidMount(){
    this._setAllStates(() => {
      this.GetClaimTypes();
      this.GetBankList();
      this.GetRelatedPolicies();
      this.GetDiagnosis();
    });
  }

  componentDidUpdate(prevProps, prevState){
    if(!Accessor.IsIdentical(prevProps, this.props, Object.keys(NewClaimW.defaultProps))){
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState((state, props) => ({
      ...props,
    }), callback);
  }

  _toForm = () => {
    this.setState({
      curStep: 0
    });
  }

  _toDisclaimer = () => {
    this.setState({
      curStep: 1
    });
  }

  _toSuccess = () => {
    this.setState({
      curStep: 2
    });
  }

  _onAgreeChange = (formValue) => {
    this.setState({
      agreeForm: formValue
    });
  }

  validQ1 = () => {
    let {formValue} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(formValue, 
      [
        "maidID", 
        "policyID",
        "startAt",
        "endAt",
        "claimType",
        "diagnosis",
        "claimIncurred",
        "claimDate"
      ], "required");
    if(!valid) return false;
    let attachments = Accessor.Get(formValue, "attachments");
    if(attachments?.length > 0){
      valid = ZValidate.CheckUploads(formValue, ["attachments"]);
      if(!valid) return false;
    }
    let claimIncurred = Accessor.Get(formValue, "claimIncurred");
    if(claimIncurred <= 0){
      return false;
    }
    return true;
  }

  _validAgree = () => {
    let {agreeForm} = this.state;
    let valid = true;
    valid = ZValidate.CheckAllFields(agreeForm, ["agreement"], "boolTrue");
    if(!valid) return false;
    return true;
  }

  _toSubmit = async () => {
    this.setState({
      loading: true
    }, async () => {
      let {formValue} = this.state;
      let res = await ReqX.SendBE("/Web/DCustomer/SubmitNewClaim", {
        ...formValue
      });
      let {Success} = res;
      if(Success){
        this.setState({
          loading: false
        }, () => {
          this._toSuccess();
        });
      }else{
        this.setState({
          loading: false
        });
        GFunc.Ask({
          EN: "Network problem.",
          TC: "網絡問題"
        },
        {
          EN: "Please try again later.",
          TC: "請稍後再試。"
        });
      }
    });
    
  }

  _close = () => {
    let {Refresh} = this.props;
    Refresh?.();
    GFunc.CloseBackdrop();
  }

  _onFormChange = (formValue) => {
    let claimIncurred = Accessor.Get(formValue, "claimIncurred");
    claimIncurred = ZMath.Cap(claimIncurred ?? 0, 0, Infinity);
    Accessor.Set(formValue, "claimIncurred", claimIncurred);
    this.setState({
      formValue
    });
  }

  GetBankList = async () => {
    let docs = await VarList.GetList("Bank");
    this.setState({
      banks: docs
    });
  }

  GetClaimTypes = async () => {
    let docs = await VarList.GetList("ClaimType");
    this.setState({
      claimTypes: docs
    });
  }

  GetDiagnosis = async () => {
    let docs = await VarList.GetList("Diagnosis");
    this.setState({
      diagnosis: docs
    });
  }

  GetRelatedPolicies = async (_id) => {
    this.setState({
      loading: true
    }, async () => {
      let res = await ReqX.SendBE("/Web/DCustomer/GetRelatedPolicies");
      let {Success, payload} = res;
      if(Success){
        let {policyDocs, maidDocs} = payload;
        this.setState({
          policyDocs: policyDocs,
          maidDocs: maidDocs,
          loading: false
        });
      }
    });
  }

  SetHelperFilter = (_id) => {
    let {formValue} = this.state;
    Accessor.Set(formValue, "maidID", _id);
    Accessor.Set(formValue, "startAt", null);
    Accessor.Set(formValue, "endAt", null);
    Accessor.Set(formValue, "policyID", null);
    Accessor.Set(formValue, "claimDate", null);
    this.setState({
      f_maidID: _id,
      f_policyID: null,
      formValue: formValue
    });
  }

  SetPolicyFilter = (_id) => {
    let {policyDocs, formValue, f_maidID} = this.state;
    let pDoc = _.find(policyDocs, o => o._id === _id);
    Accessor.Set(formValue, "startAt", pDoc.startAt);
    Accessor.Set(formValue, "endAt", pDoc.endAt);
    Accessor.Set(formValue, "policyID", pDoc._id);

    this.setState({
      f_policyID: _id,
      f_maidID: f_maidID,
      formValue: formValue
    });
  }

  renderSuccess(){
    return (
      <VStack fullWidth spacing={16} pT={30}>
        <VStack fullWidth fitHeightToContent spacing={30}>
          <HStack pH={16}>
            <XText fontSize={36} color={ColorX.CSS("Leaf")} bold>
              {LocaleX.Parse({
                EN: "Claim Form Submitted",
                TC: "索賠表已提交"
              })}
            </XText>
          </HStack>
          <HStack pH={16} width={"70%"}>
            <XText fontSize={14} color={ColorX.CSS("Stone")} textAlign="|" bold>
              {LocaleX.Parse({
                EN: "Results will be returned within 14 days from the date you submitted the claim form via your registered email.",
                TC: "結果將在您透過註冊電子郵件提交索賠表之日起 14 天內回傳。"
              })}
            </XText>
          </HStack>
          <HStack>
            <XButton {...Styles.QFBtnInverse} width={200} onPress={this._close}
              padding={0} pV={8}>
              <HStack>
                <XText bold>
                  {LocaleX.Parse({
                    EN: "Back to dashboard",
                    TC: "返回"
                  })}
                </XText>
              </HStack>
            </XButton>
          </HStack>
        </VStack>
        <HStack spacing={16} 
          style={{
            borderTopWidth: 1, 
            borderTopStyle: "solid",
            borderTopColor: ColorX.CSS("greyOut", 0.3)
          }} 
          HAlign="]" pH={16}>
          <XButton fitWidthToContent onPress={this._close}
            color={ColorX.CSS("Axit")}>
            <HStack>
              <XText bold>
                {LocaleX.Parse({
                  EN: "Back",
                  TC: "返回"
                })}
              </XText>
            </HStack>
          </XButton>
        </HStack>        
      </VStack>
    );
  }

  renderClaimForm(){
    let {formValue, maidDocs, policyDocs,
      f_maidID, claimTypes, diagnosis, loading
    } = this.state;

    if(f_maidID){
      policyDocs = _.filter(policyDocs, o => o?.insuredID === f_maidID);
    }

    let {startAt, endAt} = formValue;

    let _maidID = Accessor.Get(formValue, "maidID");

    return (
      <VStack fullWidth pV={16}>
        <XScroll height={600} fullWidth pH={16} pB={50}>
          <QForm value={formValue} spacing={10} onChange={this._onFormChange}>
            {loading && 
              <HStack>
                <ActivityIndicator loading={loading}/>
              </HStack>}
            {QUICKUI.WebDropdown("maidID", 
              { EN: "Helper's name", TC: "助理姓名" },
              maidDocs,
              {
                placeholder: { EN: "Select Helper's name", TC: "選擇工人姓名" },
                capAccessor: "fullName",
                valAccessor: "_id",
                onSelectChange: this.SetHelperFilter,
                readOnly: loading,
                errorMessage:
                  !loading && 
                  ZValidate.GetErrorMsg(Accessor.Get(formValue, "maidID"), 
                  ["required"])
              })}
            <HStack spacing={16}>
              {QUICKUI.WebDropdown("policyID", 
                { EN: "Policy no.", TC: "保單編號" },
                policyDocs,
                {
                  placeholder: { EN: "Select Policy no.", TC: "選擇保單編號" },
                  capAccessor: "policyNo",
                  valAccessor: "_id",
                  onSelectChange: this.SetPolicyFilter,
                  width: "50%",
                  readOnly: loading || !_maidID,
                  errorMessage: 
                    !loading && _maidID &&
                    ZValidate.GetErrorMsg(Accessor.Get(formValue, "policyID"), 
                    ["required"])
                })}
              <VStack width={"50%"}>
                <HStack HAlign="[" spacing={4}>
                  <XText fontSize={12} color={ColorX.CSS("Stone")}>
                    {LocaleX.Parse({EN: "Insurance period", TC: "保險期間"})}
                  </XText>
                </HStack>
                <HStack HAlign="[" spacing={4} pV={8} height={45} bW={1}
                  bColor={ColorX.CSS("Gray5")} pH={10}
                  >
                  <XText fontSize={14} color={ColorX.CSS("Stone")}
                    textAlign={"["}
                    p={12}>
                    {(startAt && endAt) ?
                     `${ZTime.Moment(startAt).format("DD/MM/YYYY")} - ${ZTime.Moment(endAt).format("DD/MM/YYYY")}`
                    : "---"}
                  </XText>
                </HStack>
              </VStack>
            </HStack>
            <HStack spacing={16}>
              {QUICKUI.WebTextField("clinic", 
                { EN: "Clinic/Hospital Name", TC: "診所/醫院名稱" },
                { width: "50%", 
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(formValue, "clinic"), 
                    ["required"])
                }
              )}
              {QUICKUI.WebTextField("doctor", 
                { EN: "Doctor's Name", TC: "醫生姓名" },
                { width: "50%", 
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(formValue, "doctor"), 
                    ["required"])
                }
              )}
            </HStack>
            <HStack spacing={16}>
              {QUICKUI.WebDropdown("claimType", 
                { EN: "Claim Type", TC: "索賠類型" },
                claimTypes,
                {
                  placeholder: { EN: "Claim Type", TC: "索賠類型" },
                  capAccessor: "name",
                  valAccessor: "_id",
                  width: "50%",
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(formValue, "claimType"), 
                    ["required"])
                })}
              {QUICKUI.WebDropdown("diagnosis", 
                { EN: "Diagnosis", TC: "診斷" },
                diagnosis,
                {
                  placeholder: { EN: "Diagnosis", TC: "診斷" },
                  capAccessor: "name",
                  valAccessor: "_id",
                  width: "50%",
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(formValue, "diagnosis"), 
                    ["required"])
                }
              )}
            </HStack>
            <HStack spacing={16}>
            {QUICKUI.WebTextField("claimIncurred", 
                { EN: "Claim Incurred", TC: "索償金額" },
                { width: "50%", type: "number", placeholder: "HKD", min: 0,
                  errorMessage: 
                    ZValidate.GetErrorMsg(Accessor.Get(formValue, "claimIncurred"), 
                    ["required"]) }
              )}
              {QUICKUI.WebDateField("claimDate", 
                { EN: "Date of consultation", TC: "諮詢日期" },
                { width: "50%", placeholder: { EN: "Date of consultation", TC: "諮詢日期" },
                minDate: ZTime.Moment(startAt).add(8, "days").toISOString(),
                errorMessage: 
                  ZValidate.GetErrorMsg(Accessor.Get(formValue, "claimDate"), 
                  ["required"]) }
              )}
            </HStack>
            <QFDropUpload 
              btnBgColor={ColorX.CSS("Axit")}
              color={ColorX.CSS("Stone")}
              previewColor={ColorX.CSS("Leaf")}
              fileSizeLimit={10} 
              name="attachments" 
              instantUpload 
              accept=".jpg,.png,.pdf,.jpeg" 
              multiple/>
          </QForm>
        </XScroll>
        {QUICKUI.PopupFooterButton(this._close,
          this._toDisclaimer, {
            backCap: {EN: "Close", TC: "關閉"},
            validateNext: this.validQ1
          })}
      </VStack>
    );
  }

  renderDisclaimer(){
    let {agreeForm, loading} = this.state;
    return (
      <QForm onChange={this._onAgreeChange} value={agreeForm}>
        <XScroll height={600} fullWidth pH={16} pV={16}>
          <XText color={ColorX.CSS("Blood")}>
            {LocaleX.Parse({
              EN: "Please read this policy carefully to submit claim.",
              TC: "請仔細閱讀本保單以提交索賠。"
            })}
          </XText>
          <XText>
            {HTMLReactParser(LocaleX.Parse({
              EN: disclaimerEN,
              TC: disclaimerTC
            }))}
          </XText>
          <HStack spacing={5} HAlign="[" pV={20}>
            <QFCheckBox name="agreement"
              bColor={ColorX.CSS("pureWhite")}
              bgColor={ColorX.CSS("pureWhite")} color={ColorX.CSS("Axit")} />
            <XText color={ColorX.CSS("Axit")} fontSize={14}>
              {LocaleX.Parse({
                EN: "I have read all terms and conditions above.",
                TC: "我已閱讀上述所有條款和條件。"
              })}
            </XText>
          </HStack>
        </XScroll>
        {QUICKUI.PopupFooterButton(this._toForm, this._toSubmit, {
          backCap: {EN: "Back", TC: "返回"},
          nextCap: {EN: "Submit", TC: "提交"},
          validateNext: this._validAgree
        }, loading)}
      </QForm>
    );
  }

  renderMain(){
    let {curStep} = this.state;
    switch(curStep){
      default: case 0: return this.renderClaimForm();
      case 1: return this.renderDisclaimer();
      case 2: return this.renderSuccess();
    }
  }

  renderTitleBar(){
    return (
      <HStack pH={16} shadow>
        <XText fontSize={16} bold>
          {LocaleX.Parse({
            EN: "Add new claim",
            TC: "新增索償"
          })}
        </XText>
        <Spacer/>
        <XIconButton onPress={this._close}>
          {IconX.Get("ant", "close", 20, ColorX.CSS("Stone"))}
        </XIconButton>
      </HStack>
    );
  }

  render(){
    return (
      <VStack bgColor={ColorX.CSS("NotQuiteWhite")}
        width={705} maxHeight={window.innerHeight * 0.9}>
        {this.renderTitleBar()}
        <VStack fullWidth>
          {this.renderMain()}
        </VStack>
      </VStack>
    );
  }

}

export default observer(NewClaimW);
